module.exports = __webpack_public_path__ + "img/none.2f6f7422.png";